import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import tokenService from './TokenService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [email, setEmail] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const updateUserInfo = () => {
    const decodedToken = tokenService.decodeToken();
    if (decodedToken) {
      setIsAdmin(decodedToken['custom:isAdmin'] === 'true');
      setEmail(decodedToken.email);
      setIsAuthenticated(true);
    } else {
      setIsAdmin(false);
      setEmail('');
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    // Initial check
    const initAuth = async () => {
      const isValid = await tokenService.validateToken();
      if (isValid) {
        updateUserInfo();
      }
      setIsLoading(false);
    };

    initAuth();

    // Setup periodic token validation
    const tokenCheckInterval = setInterval(
      async () => {
        await tokenService.validateToken();
        updateUserInfo();
      },
      5 * 60 * 1000
    ); // Check every 5 minutes

    return () => clearInterval(tokenCheckInterval);
  }, []);

  const logout = () => {
    tokenService.logout();
    setIsAuthenticated(false);
    setIsAdmin(false);
    setEmail('');
  };

  const value = {
    isAdmin,
    email,
    isAuthenticated,
    isLoading,
    logout,
    validateToken: tokenService.validateToken.bind(tokenService)
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useAuth = () => useContext(AuthContext);
